// import { User } from `@/context/AuthContext`
import { getISODay, addDays } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

// export function getTotalPointsByType(user: User, pointType: string) {
// 	try {
// 		return user.point_categories[pointType]
// 	} catch {
// 		return 0
// 	}
// }

export function getClosestDaysOfNextWeek(dayOfWeek: number, fromDate = new Date()) {
  // Mon: 1, Tue: 2, Wed: 3, Thur: 4, Fri: 5, Sat: 6, Sun: 7
  const dayOfWeekMap = [0, 1, 2, 3, 4, 5, 6];

  // Converte hora local para PST
  const zonedFrom = utcToZonedTime(fromDate.toISOString(), `America/Los_Angeles`);

  // Horário local da máquina do usuario
  const localFrom = zonedTimeToUtc(zonedFrom, `America/Los_Angeles`);

  // Horário do Brasil
  const brazilFrom = utcToZonedTime(fromDate.toISOString(), `America/Sao_Paulo`);

  /*console.log(`UTC`)
	console.log(fromDate.toUTCString())
	console.log(fromDate.toISOString())
	console.log(`\nPST`)
	console.log(zonedFrom.toUTCString())
	console.log(zonedFrom.toISOString())
	console.log(zonedFrom.toLocaleString())
	console.log(`\nBRAZIL`)
	console.log(brazilFrom.toUTCString())
	console.log(brazilFrom.toISOString())
	console.log(brazilFrom.toLocaleString())
	console.log(`\nLOCAL`)
	console.log(localFrom.toUTCString())
	console.log(localFrom.toISOString())
	console.log(localFrom.toLocaleString())*/

  const offsetDaysToFirstDate = 7 - (getISODay(localFrom) - dayOfWeekMap[dayOfWeek]);
  const offsetDaysToSecondDate = 14 - (getISODay(localFrom) - dayOfWeekMap[dayOfWeek]);

  const firstDayOfWeek = addDays(localFrom, offsetDaysToFirstDate);
  const secondDayOfWeek = addDays(localFrom, offsetDaysToSecondDate);

  // return [ format(firstDayOfWeek, `EEE, MM-dd-yyyy`), format(secondDayOfWeek, `EEE, MM-dd-yyyy`)]
  return [firstDayOfWeek, secondDayOfWeek];
}

export function getMonthName(number: any): string {
  if (typeof number !== 'number') {
    return number;
  }

  const months = [
    `Janeiro`,
    `Fevereiro`,
    `Março`,
    `Abril`,
    `Maio`,
    `Junho`,
    `Julho`,
    `Agosto`,
    `Setembro`,
    `Outubro`,
    `Novembro`,
    `Dezembro`,
  ];

  if (number < 1 || number > 12) {
    return `Número inválido`;
  }

  return months[number - 1];
}

type level = 'iniciante' | 'flap' | 'valeu' | 'mandou' | 'uau' | 'nenhum';

export function getLevelDescription(level: level): string {
  switch (level) {
    case 'iniciante':
      return `Para atingir o próximo <b>nível Sou FLAP 360°</b> você precisa ter enviado pelo menos 5 reconhecimentos para participantes diferentes, ter utilizado os 3 tipos de pontuação (Curti, Top e Arrasou), receber reconhecimentos de pelo menos 5 pessoas diferentes e atingir pelo menos 2.000 pontos.`;
    case 'flap':
      return `Para atingir o próximo <b>nível Curti</b> Para atingir o próximo Nível Curti, você ter pelo menos 3.000 pontos e estar com a pontuação classificada entre as 30% melhores do seu grupo.`;
    case 'valeu':
      return `Para atingir o próximo <b>nível Top</b> você precisa atingir pelo menos 4.000 pontos e estar com a pontuação classificada entre as 20% melhores do seu grupo. <br /> Atenção: você retornará ao nível anterior, caso sua pontuação não permaneça entre as 30% melhores do seu grupo.`;
    case 'mandou':
      return `Para atingir o próximo e último nível Arrasou você precisa atingir pelo menos 5.000 pontos e estar com a pontuação classificada entre as 10% melhores do seu grupo.<br /> Atenção: você poderá retornar a um dos níveis anteriores, caso sua pontuação não permaneça entre as 20% melhores do seu grupo.`;
    case 'uau':
      return `Atenção: você poderá retornar a um dos níveis anteriores, caso sua pontuação não permaneça entre as 10% melhores do seu grupo.`;
    default:
      return `Para atingir o <strong>nível iniciante</strong> você precisa enviar pelo menos 1 reconhecimento.`;
  }
}

export function getLevelTitle(level: level): string {
  switch (level) {
    case 'iniciante':
      return `Iniciante`;
    case 'flap':
      return `Sou FLAP 360°`;
    case 'valeu':
      return `Curti`;
    case 'mandou':
      return `Top`;
    case 'uau':
      return `Arrasou`;
    default:
      return `---`;
  }
}

export const ineligibleIdsArray = [
  13085, 13088, 13087, 3003, 13089, 13092, 13022, 13090, 13080, 13025, 3002, 13082, 13084, 13094, 13083, 13070, 13020, 13021,
  13026, 4005, 13000, 13071, 3001,
];
